import { render, staticRenderFns } from "./prodFam.vue?vue&type=template&id=2d0d2834&scoped=true"
import script from "./prodFam.vue?vue&type=script&lang=js"
export * from "./prodFam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0d2834",
  null
  
)

export default component.exports